import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DeviceService } from '@shared/services';
import { RouterState, RoutingService } from '@spartacus/core';
import { HamburgerMenuService } from '@spartacus/storefront';
import { CurrentProfile } from '@user/const';
import { CurrentProfileService } from '@user/feature';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sd-mobile-login-button',
  templateUrl: './mobile-login-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MobileLoginButtonComponent implements OnInit {
  isActive$: Observable<boolean>;
  currentProfile$: Observable<CurrentProfile>;

  constructor(
    private hamburgerMenuService: HamburgerMenuService,
    private currentProfileService: CurrentProfileService,
    private routingService: RoutingService,
    public deviceService: DeviceService,
  ) {}

  ngOnInit(): void {
    this.isActive$ = combineLatest({
      isExpanded: this.hamburgerMenuService.isExpanded,
      state: this.routingService.getRouterState().pipe(map((routerState: RouterState) => routerState.state)),
    }).pipe(
      map(
        ({ isExpanded, state }) =>
          !isExpanded && (state.url.includes('/my-account') || state.semanticRoute === 'login'),
      ),
    );

    this.currentProfile$ = this.currentProfileService.get();
  }
}
